import { render } from "./LoadingAnimation.vue?vue&type=template&id=2094b562"
import script from "./LoadingAnimation.vue?vue&type=script&lang=js"
export * from "./LoadingAnimation.vue?vue&type=script&lang=js"

import "./LoadingAnimation.vue?vue&type=style&index=0&id=2094b562&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__